import { dbAdapter } from './databaseAdapter';

export const staffService = {
  getAll: async () => {
    try {
      return await dbAdapter.get('staff');
    } catch (error) {
      console.error('Error getting staff:', error);
      throw new Error(error.message || 'Gagal mengambil data staff');
    }
  },
  
  getById: async (id) => {
    try {
      return await dbAdapter.getById('staff', id);
    } catch (error) {
      console.error('Error getting staff by id:', error);
      throw new Error(error.message || 'Gagal mengambil data staff');
    }
  },
  
  getActive: async () => {
    try {
      const staff = await dbAdapter.get('staff');
      return staff.filter(s => s.status === 'active');
    } catch (error) {
      console.error('Error getting active staff:', error);
      return [];
    }
  },
  
  create: async (data) => {
    try {
      const newStaff = {
        id: `STAFF-${Date.now()}`,
        ...data,
        status: data.status || 'active',
        joinDate: data.joinDate || new Date().toISOString().split('T')[0],
        photo: data.photo || '',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      return await dbAdapter.create('staff', newStaff);
    } catch (error) {
      console.error('Error creating staff:', error);
      throw new Error(error.message || 'Gagal membuat staff');
    }
  },
  
  update: async (id, data) => {
    try {
      console.log('📤 [update] Staff data:', data);
      return await dbAdapter.update('staff', id, data);
    } catch (error) {
      console.error('Error updating staff:', error);
      throw new Error(error.message || 'Gagal mengupdate staff');
    }
  },
  
  delete: async (id) => {
    try {
      // Check if staff has active work orders
      const workOrders = await dbAdapter.get('work_orders');
      const hasActiveOrders = workOrders.some(wo => 
        wo.staffId === id && // ← FIX: cuma camelCase
        wo.status !== 'completed' && 
        wo.status !== 'cancelled'
      );
      if (hasActiveOrders) {
        throw new Error('Staff has active work orders. Complete or reassign them first.');
      }
      return await dbAdapter.delete('staff', id);
    } catch (error) {
      console.error('Error deleting staff:', error);
      throw new Error(error.message || 'Gagal menghapus staff');
    }
  }
};